import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
export function CredibilitySection() {
  return <section className="py-24 px-6 bg-navy-dark border-t border-white/5" data-id="element-12">
      <div className="max-w-6xl mx-auto" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-14">
          <div className="order-2 lg:order-1" data-id="element-15">
            <FadeIn data-id="element-16">
              <h2 className="text-3xl md:text-5xl font-serif mb-8" data-id="element-17">
                No es consultoría <span className="text-gold" data-id="element-18">tradicional</span>
              </h2>
            </FadeIn>

            <div className="space-y-6 text-lg md:text-xl text-gray-light font-sans mb-10" data-id="element-19">
              <FadeIn delay={0.1} data-id="element-20">
                <p data-id="element-21">
                  Mi enfoque no se basa en dar recomendaciones sueltas. Trabajo
                  entendiendo el negocio como un sistema.
                </p>
              </FadeIn>
              <FadeIn delay={0.2} data-id="element-22">
                <p data-id="element-23">
                  Soy ingeniero y llevo más de 20 años construyendo y operando
                  negocios. Eso me permite ver dónde está realmente el desorden,
                  qué parte de la operación falla, y cómo estructurar el negocio
                  correctamente.
                </p>
              </FadeIn>
            </div>

            <FadeIn delay={0.3} data-id="element-24">
              <p className="text-2xl md:text-3xl font-serif text-gold italic" data-id="element-25">
                No desde teoría. Desde experiencia real.
              </p>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-26">
            <FadeIn delay={0.2} direction="left" data-id="element-27">
              <div className="relative w-full max-w-md aspect-[4/5] rounded-lg border border-gold/30 bg-navy overflow-hidden flex items-center justify-center" data-id="element-28">
                <div className="relative z-10 p-12 flex items-center justify-center" data-id="element-29">
                  <img src="https://cdn.magicpatterns.com/uploads/8iq9FdZPWhhg1moFGMfStg/Gemini_Generated_Image_vohteevohteevoht_(1)-Photoroom.png" alt="Oscar Rodriguez" className="w-full max-w-[280px] object-contain" loading="lazy" data-id="element-30" />
                </div>

                {/* Decorative corners */}
                <div className="absolute top-4 left-4 w-8 h-8 border-t border-l border-gold/50" data-id="element-31"></div>
                <div className="absolute top-4 right-4 w-8 h-8 border-t border-r border-gold/50" data-id="element-32"></div>
                <div className="absolute bottom-4 left-4 w-8 h-8 border-b border-l border-gold/50" data-id="element-33"></div>
                <div className="absolute bottom-4 right-4 w-8 h-8 border-b border-r border-gold/50" data-id="element-34"></div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}